// Mock data for Collado Ubeda Vanesa consulting website

export const mockServices = [
  {
    id: 1,
    title: "Stratégie Digitale",
    description: "Développez une stratégie digitale sur mesure pour atteindre vos objectifs business. Analyse de marché, positionnement, et plan d'action détaillé.",
    icon: "Target",
    features: [
      "Audit digital complet",
      "Définition des KPIs",
      "Plan d'action stratégique",
      "Roadmap digitale"
    ]
  },
  {
    id: 2,
    title: "Analytics & Reporting",
    description: "Mesurez et optimisez vos performances digitales avec des tableaux de bord personnalisés et des rapports détaillés.",
    icon: "BarChart3",
    features: [
      "Configuration Google Analytics",
      "Tableaux de bord personnalisés",
      "Rapports mensuels détaillés",
      "Recommandations d'optimisation"
    ]
  }
];

export const mockCompanyInfo = {
  name: "Collado Ubeda Vanesa",
  siren: "991 212 713",
  tagline: "Votre partenaire en transformation digitale",
  description: "Expert en consulting et marketing digital, nous accompagnons les entreprises dans leur transformation numérique avec des solutions sur mesure et orientées résultats.",
  mission: "Notre mission est d'aider les entreprises à maximiser leur potentiel digital grâce à des stratégies innovantes et des analyses précises.",
  values: [
    {
      title: "Expertise",
      description: "Une connaissance approfondie des dernières tendances et technologies digitales"
    },
    {
      title: "Sur-mesure",
      description: "Des solutions adaptées à vos besoins spécifiques et à votre secteur"
    },
    {
      title: "Résultats",
      description: "Une approche orientée ROI avec des objectifs mesurables"
    }
  ],
  stats: [
    { value: "50+", label: "Clients accompagnés" },
    { value: "95%", label: "Taux de satisfaction" },
    { value: "200%", label: "ROI moyen" }
  ]
};

export const mockTestimonials = [
  {
    id: 1,
    name: "Sophie Martin",
    role: "CEO",
    company: "TechStart SAS",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    rating: 5,
    text: "Collado Ubeda Vanesa a transformé notre stratégie digitale. En 6 mois, notre trafic a augmenté de 250% et nos conversions ont doublé. Une expertise exceptionnelle !",
    result: "+250% de trafic"
  },
  {
    id: 2,
    name: "Marc Dubois",
    role: "Directeur Marketing",
    company: "E-Commerce Plus",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
    rating: 5,
    text: "Les tableaux de bord analytics créés par Vanesa nous ont permis de prendre des décisions data-driven. Le ROI est mesurable et impressionnant. Je recommande vivement !",
    result: "+180% ROI"
  },
  {
    id: 3,
    name: "Claire Rousseau",
    role: "Fondatrice",
    company: "BeautyBox France",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
    rating: 5,
    text: "Un accompagnement sur-mesure et une compréhension parfaite de nos besoins. Notre présence digitale est désormais notre principal levier de croissance. Merci Vanesa !",
    result: "+320% ventes en ligne"
  },
  {
    id: 4,
    name: "Thomas Leblanc",
    role: "Co-fondateur",
    company: "FitLife App",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    rating: 5,
    text: "La stratégie digitale mise en place a dépassé toutes nos attentes. Des insights précieux et un suivi régulier qui fait toute la différence. Une vraie partenaire de croissance.",
    result: "+150% utilisateurs actifs"
  },
  {
    id: 5,
    name: "Laura Petit",
    role: "Responsable Digital",
    company: "Immo Connect",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop",
    rating: 5,
    text: "Professionnalisme, réactivité et résultats concrets. Les rapports mensuels nous permettent d'ajuster notre stratégie en temps réel. Un investissement qui en vaut vraiment la peine.",
    result: "+90% leads qualifiés"
  },
  {
    id: 6,
    name: "Julien Bernard",
    role: "Gérant",
    company: "Restaurant Le Gourmet",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    rating: 5,
    text: "Grâce à l'optimisation de notre présence en ligne, nos réservations ont explosé. Vanesa a su comprendre les spécificités de notre secteur. Un grand merci pour ces résultats !",
    result: "+200% réservations"
  }
];

export const mockTimeSlots = [
  { id: 1, date: "2024-12-23", time: "10:00", available: true },
  { id: 2, date: "2024-12-23", time: "14:00", available: true },
  { id: 3, date: "2024-12-23", time: "16:00", available: false },
  { id: 4, date: "2024-12-24", time: "10:00", available: true },
  { id: 5, date: "2024-12-24", time: "14:00", available: true },
  { id: 6, date: "2024-12-26", time: "10:00", available: true },
  { id: 7, date: "2024-12-26", time: "11:00", available: true },
  { id: 8, date: "2024-12-26", time: "15:00", available: true }
];

// Mock function to simulate appointment booking
export const mockBookAppointment = (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Appointment booked (mock):", appointmentData);
      resolve({
        success: true,
        message: "Rendez-vous confirmé !",
        appointmentId: Math.random().toString(36).substr(2, 9)
      });
    }, 1000);
  });
};

// Mock function to simulate contact form submission
export const mockSubmitContact = (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted (mock):", contactData);
      resolve({
        success: true,
        message: "Message envoyé avec succès !"
      });
    }, 1000);
  });
};
